import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { StandardPolicyGuard } from 'src/auth/guard';
// layouts
import AppLayout from 'src/layouts/app';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// Lazy load page components
const RecommendationListPage = lazy(
  () => import('src/pages/recommendations/RecommendationListPage')
);
const RecommendationDetailsPage = lazy(
  () => import('src/pages/recommendations/RecommendationDetailsPage')
);

export const recommendationRoutes = [
  {
    path: 'recommendations',
    element: (
      <StandardPolicyGuard
        fallback={
          <AppLayout>
            <LoadingScreen />
          </AppLayout>
        }
      >
        <AppLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </AppLayout>
      </StandardPolicyGuard>
    ),
    children: [
      { path: '', element: <RecommendationListPage />, index: true },
      { path: 'details/:id', element: <RecommendationDetailsPage /> },
    ],
  },
];
